
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock-ideas",
      function () {
        return require("private-next-pages/stock-ideas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock-ideas"])
      });
    }
  